"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsMappers = void 0;
/**
 * Keeping as an empty object for backwards compatabillity
 */
exports.componentsMappers = {};
//# sourceMappingURL=componentExtensions.js.map